import { useState, useEffect } from 'react';

export const useShrink = () => {
  const [shrink, setShrink] = useState<boolean>(false);
  const eMainScroll = document.body as HTMLElement;

  useEffect(() => {
    eMainScroll.onscroll = detectShrink;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eMainScroll]);

  function detectShrink() {
    setShrink(eMainScroll.scrollTop > 1 || document.documentElement.scrollTop > 1);
  }

  return { shrink };
};
